@layer reset, default, fixed, container;

@layer reset {
  :host {
    display: block;
  }
}

@layer default {
  :host .gcds-verify-banner {
    font: var(--gcds-verify-banner-font);
    background-color: var(--gcds-verify-banner-background);
    color: var(--gcds-verify-banner-text);

    :is(summary, .verify-banner__content) {
      font-size: 90%;
    }

    summary {
      display: flex;
      margin-inline: auto;
      padding-block: var(--gcds-verify-banner-summary-padding);
      cursor: pointer;

      :is(.svg-container, p small) {
        margin: var(--gcds-verify-banner-summary-content-margin);
      }

      p {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        line-height: var(--gcds-verify-banner-line-height);
        margin: 0;
      }

      .verify-banner__toggle {
        flex: 0 0 auto;
        border: 0;
        background: none;
        padding: 0;
        pointer-events: none;
        font-weight: var(--gcds-verify-banner-toggle-font-weight);
        color: var(--gcds-verify-banner-toggle-text);
        text-decoration: underline;

        .svg-container path {
          fill: var(--gcds-verify-banner-toggle-text);
        }
      }
    }

    .verify-banner__content {
      margin: 0 auto;
      padding-block-start: var(
        --gcds-verify-banner-content-padding-block-start
      );
      padding-block-end: var(--gcds-verify-banner-content-padding-block-end);
      border-block-start: var(--gcds-verify-banner-content-border-width) solid
        var(--gcds-verify-banner-content-border-color);

      li {
        list-style: none;

        :is(h4, p) {
          width: 90%;
        }
      }

      h4 {
        margin: var(--gcds-verify-banner-content-heading-margin);
      }

      p {
        line-height: var(--gcds-verify-banner-line-height);
        margin: 0;
      }
    }

    &[open] summary .verify-banner__toggle svg {
      transform: rotate(-180deg);
    }
  }
}

@layer fixed {
  :host .gcds-verify-banner {
    &.verify-banner--is-fixed {
      position: sticky;
      top: 0;
      width: var(--gcds-verify-banner-max-content-width-full);
      z-index: 9999;
    }
  }
}

@layer container {
  :host .gcds-verify-banner {
    .container-xl,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xs {
      width: 90%;
    }

    .container-full {
      max-width: var(--gcds-verify-banner-container-full);
      padding-inline: var(--gcds-verify-banner-container-padding);
    }

    .container-xl {
      max-width: var(--gcds-verify-banner-container-xl);
    }

    .container-lg {
      max-width: var(--gcds-verify-banner-container-lg);
    }

    .container-md {
      max-width: var(--gcds-verify-banner-container-md);
    }

    .container-sm {
      max-width: var(--gcds-verify-banner-container-sm);
    }

    .container-xs {
      max-width: var(--gcds-verify-banner-container-xs);
    }
  }
}
